













































import Vue from "vue";
import { ApplicationPartGet } from "@infoland/iprova-api";
import storeHelper from "./../../store/store-helper";
import shared from "@/shared";

export default Vue.extend({
    name: "ApplicationPartList",
    props: {
        showAll: Boolean
    },
    data: () => ({}),
    computed: {
        skeletonType(): string {
            return `list-item@${this.showAll ? 5 : 1}`;
        },
        applicationParts(): ApplicationPartGet[] {
            const parts = storeHelper.siteStore.applicationParts;
            if (parts) {
                if (this.showAll) {
                    return parts;
                } else
                    return parts.filter(p => {
                        return p.favorite;
                    });
            } else {
                return null;
            }
        }
    },
    methods: {
        toggleFavorite: async function (event, applicationPart: ApplicationPartGet) {
            event.preventDefault();
            await storeHelper.siteStore.updateFavoriteForApplicationPart({
                application_part_id: applicationPart.application_part_id,
                favorite: !applicationPart.favorite
            });
        },
        getAppUrl: function (url: string) {
            return `${shared.iProvaUrl}/${url}`;
        }
    }
});
